export default __webpack_public_path__ + "static/media/black-back.3dab1922.png";